import Vue from 'vue'
import axios from 'axios'

export default {
  namespaced: true,
  state: {
    config: {},
    loaded: false
  },
  mutations: {
    setConfig (state, configs) {
      for (const config of configs) {
        Vue.set(state.config, config.attribute, config.value)
      }

      Vue.set(state, 'loaded', true)
    }
  },
  getters: {
    getConfig: state => {
      return state.config
    },
    configIsLoaded: state => {
      return state.loaded
    }
  },
  actions: {
    async fetchConfig ({ commit }) {
      await axios.get(process.env.VUE_APP_API_URL + '/config')
        .then(response => commit('setConfig', response.data))
        .catch(_ => alert())
    }
  }
}
